
import React, { useState, useCallback, Fragment } from 'react';
import Select from 'react-select';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ButtonGroup,
} from 'reactstrap'
import { fetcher } from 'api/client';
// import {linkContract} from 'api/actions/contracts';
import { useTranslation } from 'react-i18next';
import { fetchContractList, contractAction, bulkMoveToFolder } from 'api/actions/contracts';
import { fetchFolders } from 'api/actions/folders';
import { toast } from 'components/Shared/Toast';
import { archiverFolder } from 'app-constants';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

function MoveToFolder({ isOpen, toggle, contract, onCancel, onSubmit, data, onFolderSelected }) {
    const { t } = useTranslation();


    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader toggle={toggle}>
                {t('move.title')}
            </ModalHeader>
            <ModalBody>
                <p>
                    {t('move.choose_destination')}
                </p>
                <div className="form-group">
                    <label>{t('contracts.reference.name')}:</label>
                    {/* <input type="text" className="form-control input-sm search-input" placeholder={t('contracts.reference.name_placeholder')} name="name" /> */}
                    <Select
                        styles={reactSelectStyles}
                        cacheOptions
                        defaultOptions
                        options={data?.filter(doc => doc._id !== contract.childOf).map((doc) =>
                        (
                            {
                                value: doc._id,
                                label: doc._id === archiverFolder ? t('contracts.listing.archiver') : doc.name
                            }
                        ))
                        }
                        onChange={onFolderSelected}
                        placeholder={t('move.choose')}
                        noOptionsMessage={() => <div>{t('move.no_options')}</div>}
                    />
                </div>
            </ModalBody>

            <ModalFooter className="text-center">
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button type="button" size="md" onClick={toggle}>
                        {t('contracts.reference.cancel')}
                    </Button>
                    <Button className="ml-2" size="md" color="primary" type="button" onClick={onSubmit}>
                        <i className="fas fa-save"></i> {t('contracts.reference.save')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )
}

function MoveToFolderContainer({ isOpen, toggle, isBulk, onSubmit = () => { }, contract, selectedContracts }) {
    const [selectedFolder, setSelectedFolder] = useState('');
    const { t } = useTranslation();

    const queryClient = useQueryClient();

    const { mutate: mutateMove } = useMutation((payload) => fetcher(isBulk ? bulkMoveToFolder({ ids: selectedContracts, ...payload }) : contractAction(contract._id, 'move', payload)), {
        onSuccess: () => {
            toast.success(t('move.success_move'))
            toggle()
            onSubmit()
            queryClient.invalidateQueries('fetch-folder-list');
        }, onError: () => {
            toast.error(t('move.error_move'))
        }
    });

    const handleSubmit = () => {
        if (!selectedFolder || !selectedFolder.length) return toast.error(t('move.must_choose_option'))
        mutateMove({
            childOf: selectedFolder
        })
    }

    const handleFolderSelected = (option) => {
        //`/contracts/all?filterown=true&search=name|${value}`;
        setSelectedFolder(option.value)
    }

    const { data } = useQuery('fetch-folders', () => fetcher(fetchFolders()), { enabled: isOpen });

    return (
        <MoveToFolder
            isOpen={isOpen}
            toggle={toggle}
            contract={contract}
            onSubmit={handleSubmit}
            data={data}
            onFolderSelected={handleFolderSelected}
        />
    )
}

export default MoveToFolderContainer;